module.exports = __webpack_public_path__ + "img/backgroundimg.5a27949f.jpg";